import React, { useMemo } from 'react';
import { Button } from '@this/shared/ui/inputs/button';
import type User from '@this/domain/user/user';
import MainTitle from './main_title';

interface Props {
  user: User | null | undefined;
}

const PaymentFailed: React.FC<Props> = ({ user }) => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <div style={styles.container}>
      <div style={styles.inner}>
        <MainTitle value="ご利用に関するお知らせ" />
        <div style={styles.card}>
          <p>決済処理が正しく完了できなかったため、現在サービスをご利用いただけません。</p>
          <p>決済情報をご確認ください。</p>
          <p style={styles.message}>エラーの原因としては、以下の可能性が考えられます。</p>
          <ul style={styles.list}>
            <li>クレジットカードの有効期限切れ</li>
            <li>クレジットカードの利用限度額超過</li>
            <li>その他の記入したカード情報の不備</li>
          </ul>
          <p style={styles.message}>
            利用を再開するには、管理権限を持つアカウントでクレジットカード情報を更新してください。
          </p>
          {user?.isOrganizationAdmin && (
            <Button href="/aiexpense/organization/plans" isExternal style={styles.updateButton}>
              クレジットカード情報を更新
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const getStyles = () => ({
  container: {
    padding: '30px 24px 0'
  },
  inner: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  card: {
    background: 'white',
    borderRadius: '4px',
    padding: '28px 32px',
    marginTop: '12px',
    fontSize: '1.1rem'
  },
  message: {
    marginTop: '16px'
  },
  list: {
    listStyleType: 'disc',
    marginTop: '8px',
    paddingLeft: '24px'
  },
  updateButton: {
    marginTop: '32px',
    fontSize: '1.1rem'
  }
});

export default PaymentFailed;
